import {useTranslation} from 'react-i18next';

import {Typography} from '@mui/material';

import ApplicantOnboardingForm from '../../../features/applicant/onboarding/components/form/ApplicantOnboardingForm';

interface OnboardStartedProps {
  firstName: string | undefined;
}

export default function OnboardStarted({firstName}: OnboardStartedProps) {
  const {t} = useTranslation();

  return (
    <>
      <Typography
        mt={4}
        variant='h1'
        textAlign={'center'}
        sx={{
          marginBottom: '1rem',
          lineHeight: {
            xs: '2.5rem',
            md: 'auto',
          },
        }}
      >
        {t('applicantOnboarding.greeting', {name: firstName ?? ''})}
      </Typography>
      <Typography mb={1} variant='h6' textAlign={'center'}>
        {t('applicantOnboarding.subGreeting')}
      </Typography>
      <ApplicantOnboardingForm />
    </>
  );
}
